import * as tslib_1 from "tslib";
import { ESPConnection } from "../espConnection";
var SMCService = /** @class */ (function () {
    function SMCService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "WsSMC", "1.19");
    }
    SMCService.prototype.connectionOptions = function () {
        return this._connection.opts();
    };
    SMCService.prototype.Activity = function (request) {
        return this._connection.send("Activity", request).then(function (response) {
            return tslib_1.__assign({ Running: {
                    ActiveWorkunit: []
                } }, response);
        });
    };
    return SMCService;
}());
export { SMCService };
//# sourceMappingURL=wsSMC.js.map